































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name: "CardCollapsable"
})
export default class CardCollapsable extends Vue {
    @Prop({ type: Boolean, default: false })
    public readonly startVisible!: boolean;
    @Prop({ type: String, required: true })
    public readonly title!: string;
    @Prop({ type: String, default: "secondary" })
    public readonly variant!: string;
    @Prop({ type: String, default: "" })
    public readonly bodyClass!: string;
    @Prop({ type: String, default: "" })
    public readonly cardClass!: string;

    private visible: boolean = this.startVisible;

    public setVisible(visible): void {
        this.visible = visible;
    }
}
